$(document).ready(function(){
   this.querySelectorAll('.build-your-set-slider').forEach((slider) => {
      const swiper = new Swiper(slider, {
        spaceBetween: 0,
        slidesPerView: 3,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          992: {
            slidesPerView: 7,
          }
        }
  });
      swiper.slideTo(3);
      swiper.on('slideChange', (e) => {
        if(e.activeIndex > e.previousIndex){
            var collectionHandle = $(e.el).data('handle');
            var currentUrl = window.location.pathname;
            var nextPage = $('#pagination-'+collectionHandle).find('.next').find('a').attr('href');
            var nextPageNumber = nextPage.replace(currentUrl, "");
            var nextPageUrl = currentUrl+nextPageNumber;
            fetch(nextPageUrl).then(res => res.text()).then(res => {
                $('#pagination-'+collectionHandle).replaceWith($(res).find('#pagination-'+collectionHandle));
                let pageInt = nextPageNumber.replace('?page=', "");
                $("#"+collectionHandle+' .slick_'+collectionHandle).append($(res).find('#'+collectionHandle).find('.slick_'+collectionHandle).html());
                e.update(true);
                $("#products-"+collectionHandle).append($(res).find('#products-'+collectionHandle).html());
            });
          }
        });
      swiper.on('slideChangeTransitionEnd', (e) => {
        setTimeout(function(){
          var pHandle = $(e.el).find('.swiper-slide-active .js-show-product').data("product-handle"); 
          var parentId =  $(e.el).find('.swiper-slide-active .js-show-product').data("div-id"); 
          showProductTile(pHandle,parentId);
        }, 1000);
      });
    });
   $(".build-your-set-slider").each(function(){
      var $obj = $(this);
      var pHandle = $obj.find('.swiper-slide-active').find('.js-show-product').data("product-handle"); 
      var parentId =  $obj.find('.swiper-slide-active').find('.js-show-product').data("div-id"); 
      showProductTile(pHandle,0);
   });
   $("#buildSite").click(function(){
      var countEleBtn = 0;
      $("#shopify-section-collection__grid").find(".form--product__dropdown-label-wrapper").each(function(){
        if($(this).hasClass("select-error")){
          $(this).removeClass("select-error");
        }
      });
      $("#shopify-section-collection__grid").find(".product-tile.is-active").each(function(){
        var pattr = $(this).find(".js-label-atc_disabled").hasClass('hide');
        if (!pattr) {
          $(this).find(".form--product__dropdown-label-wrapper").addClass("select-error");
          countEleBtn++;
        }
      });
      if(countEleBtn == 0){
         var formValues1 = $(".product-tile.is-active:first").find("form.form--product").serialize();
        var formValues2 = $(".product-tile.is-active").not(':first').find("form.form--product").serialize();
        $.ajax({
            type: "POST",
            url: "/cart/add",
            data: formValues1,
            dataType: "json",
            encode: true
          }).done(function(data){
                console.log("form 1 done");
                $.ajax({
                  type: "POST",
                  url: "/cart/add",
                  data: formValues2,
                  dataType: "json",
                  encode: true
              }).done(function(data){
                console.log("form 2 done");
                $(".buildSite2").trigger("click");
              });
          });
      }
      if(countEleBtn > 0){
        $(".product-tile.is-active").find(".js-label-atc_disabled.hide").parent().find(".form--product__dropdown-label-wrapper").addClass("select-error");
      }
   });
});

function showProductTile(pHandle,parentId){
  var mainPID = parentId;
  if(parentId == 0){
      $("#shopify-section-collection__grid").find(".product-tile").each(function(){
        $(this).addClass("hide");
        if($(this).hasClass("is-active")){
          $(this).removeClass("is-active");
        }
        if($(this).find(".js-open-quick-add2").hasClass("check-in")){
          $(this).find(".js-open-quick-add2").removeClass("check-in");
        }
      });
      $(".build-your-set-slider").each(function(){
        var $obj = $(this);
        var pHandle = $obj.find('.swiper-slide-active .js-show-product').data("product-handle"); 
        $(".set-collection #shopify-section-collection__grid").find(".product-tile").each(function(){
          var product_handle = $(this).data("target-handle");
          var parent_handle = $(this).parent().attr("id");
          if(pHandle == product_handle){
            if($(this).hasClass("hide")){
              $(this).removeClass("hide");
            }
            $(this).addClass("is-active");
            $(this).find(".js-open-quick-add2").addClass("check-in");
            $(this).find(".js-open-quick-add2").trigger("click");
            
          }
        });
      });
  }
  else{
    $("#shopify-section-collection__grid #products-"+mainPID).find(".product-tile").each(function(){
      $(this).addClass("hide");
      if($(this).hasClass("is-active")){
        $(this).removeClass("is-active");
      }
      if($(this).find(".js-open-quick-add2").hasClass("check-in")){
        $(this).find(".js-open-quick-add2").removeClass("check-in");
      }
    });
    $("#"+parentId).each(function(){
      var $obj = $(this);
      var pHandle = $obj.find('.swiper-slide-active .js-show-product').data("product-handle"); 
      $(".set-collection #shopify-section-collection__grid").find(".product-tile").each(function(){
          var product_handle = $(this).data("target-handle");
          var parent_handle = $(this).parent().attr("id");
          if(pHandle == product_handle){
            if($(this).hasClass("hide")){
              $(this).removeClass("hide");
            }
            $(this).addClass("is-active");
            $(this).find(".js-open-quick-add2").addClass("check-in");
            $(this).find(".js-open-quick-add2").trigger("click");
          }
      });
    });
  }
}



